import { useCallback, useContext, useEffect, useMemo, useRef, useState } from 'react';
import { useForm } from 'react-hook-form';
import useOffer from '../../api/hooks/useOffers';
import LogMessage from '../../components/misc/LogMessage';
import NavBar from '../../components/misc/NavBar';
import SearchBar from '../../components/misc/Searcbar';
import SideBar from '../../components/misc/SideBar';
import OfferCreateModal from '../../components/modals/OfferCreateModal';
import OffersTable from '../../components/offer/OffersTable';
import { logMsgBgColors } from '../../consts/misc';
import { toIcons } from '../../consts/Paths';
import MainContext from '../../context/MainContext';
import useIsMobile from '../../hooks/useIsMobile';
import useLogMessage from '../../hooks/useLogMessage';
import Lightbox from 'react-spring-lightbox';
import useToggle from '../../hooks/useToggle';
import '../../styles/Content.css';
import '../../styles/General.css';
import '../../styles/Offers.css';
import { backToTopOfPage } from '../../utils/others';
import CustomInput from '../../components/inputs/CustomInput';
import { useLocation, useNavigate } from 'react-router-dom';
import { apiURL } from '../../consts/URLs';
import { PRODUCT } from '../../api/endpointList';
import useCategory from '../../api/hooks/useCategory';
import Loader from '../../components/Loader';
import CustomModal from '../../components/modals/CustomModal';
import useConditions from '../../api/hooks/useConditions';
import useVendors from '../../api/hooks/useVendors';
import { getCookie } from '../../utils/handleCookie';
import { cookieName } from '../../consts/cookie';

const token = getCookie(cookieName.token);

const OffersPage = (props: any) => {
    const { isMobile } = useIsMobile();
    const { setRefresh, setOffer } = useContext(MainContext);
    const { RESPONSES, RESULTS, CTAs } = useOffer();
    const logMessage = useLogMessage();
    const menuToggler = useToggle(false);
    const [selectedProducts, setSelectedProducts] = useState<any[]>([]);
    const [bigLoad, setBigLoad] = useState(false);
    const [isFastEdit, setFastEdit] = useState(false);

    const [popupPublish, setPopupPublish] = useState(false);
    const [popupDelete, setPopupDelete] = useState(false);
    const [popupForceSync, setPopupForceSync] = useState(false);
    const [updateTable, setUpdateTable] = useState(false);

    // const [bigLoad, setBigLoad] = useState(false);
    /* Modal */
    const toggleOfferModal = useToggle(false);

    // const navigate = useNavigate();

    /* Forms */
    const createOfferForm = useForm();
    const searchOfferForm = useForm();

    const loadMoreToggler = useToggle(false);
    const filtersPanelToggler = useToggle(false);
    const filtersPanelRef = useRef<HTMLDivElement | null>(null);
    const { RESPONSES: RESPONSEcatgeory, RESULTS: RESULTcatgeory, CTAs: CTAsCategory } = useCategory();
    const { RESPONSES: RESPONSEConditions, RESULTS: RESULTConditions, CTAs: CTAsConditions } = useConditions();
    const { RESPONSES: RESPONSEvendors, RESULTS: RESULTvendors, CTAs: CTAsVendors } = useVendors();

    const [loadMoreCounter, setLoadMoreCounter] = useState<number>(1);
    const [searchedProducts, setSearchedProducts] = useState();
    const [searchObj, setSearchObj] = useState<any>({});
    const [categories, setCategories] = useState<any>([]);
    const [conditions, setConditions] = useState<any>([]);
    const [vendors, setVendors] = useState<{ id: number | string; name: string }[]>([]);

    const queryParam = useMemo(() => {
        const params = new URLSearchParams(window.location.search);
        let obj = {
            name: '',
            conditionId: -1,
            published: 'null',
            categoryId: -1,
            vendorId: -1,
            brand: 'null',
            price_order: 'null',
            errors: 'null',
            products_per_page: 20,
            quantity: null as number | null,
            quantity_min: null as number | null,
            quantity_max: null as number | null,
        };

        obj.name = params.get('keyword') ?? '';
        obj.conditionId = params.get('condition_id') && Number(params.get('condition_id')) !== -1 ? Number(params.get('condition_id')) : -1;
        obj.published = params.get('published') ?? 'null';
        obj.categoryId = params.get('category_id') && Number(params.get('category_id')) ? Number(params.get('category_id')) : -1;
        obj.vendorId = params.get('vendor_id') && Number(params.get('vendor_id')) !== -1 ? Number(params.get('vendor_id')) : -1;
        obj.brand = params.get('brand') ?? 'null';
        obj.price_order = params.get('price_order') ?? 'null';
        obj.errors = params.get('errors') ?? 'null';
        obj.products_per_page = params.get('products_per_page') && Number(params.get('products_per_page')) !== -1 ? Number(params.get('products_per_page')) : 20;
        obj.quantity = params.get('quantity') && !isNaN(Number(params.get('quantity'))) ? Number(params.get('quantity')) : null;
        obj.quantity_min = params.get('quantity_min') && !isNaN(Number(params.get('quantity_min'))) ? Number(params.get('quantity_min')) : null;
        obj.quantity_max = params.get('quantity_max') && !isNaN(Number(params.get('quantity_max'))) ? Number(params.get('quantity_max')) : null;


        console.log(obj);
        setSearchObj(obj);
        return obj;
    }, [window.location.search, window.location]);

    const [isLoading, setIsLoading] = useState(false);

    const tempLoading = useToggle(false);

    const [isEmpty, setIsEmpty] = useState(false);

    const publishedOptions = [
        {
            name: 'Tutti',
            id: 'null',
        },
        {
            name: 'Pubblicato',
            id: 1,
        },
        {
            name: 'Bozza',
            id: 0,
        },
    ];

    useEffect(() => {
        const url = new URL(window.location.href);
        const isEmpty = url.searchParams.get('empty');
        if (isEmpty) {
            setIsEmpty(true);
        } else setIsEmpty(false);

        const params = new URLSearchParams(window.location.search);
        const keyword = params.get('keyword') ?? '';
        const condition_id = params.get('condition_id') && Number(params.get('condition_id')) !== -1 ? Number(params.get('condition_id')) : -1;
        const published = params.get('published') ?? 'null';
        const category_id = params.get('category_id') && Number(params.get('category_id')) ? Number(params.get('category_id')) : -1;
        const vendor_id = params.get('vendor_id') && Number(params.get('vendor_id')) !== -1 ? Number(params.get('vendor_id')) : -1;
        const brand = params.get('brand') ?? 'null';
        const price_order = params.get('price_order') ?? 'null';
        const errors = params.get('errors') ?? 'null';
        const products_per_page = params.get('products_per_page') && Number(params.get('products_per_page')) !== -1 ? Number(params.get('products_per_page')) : 20;
        const quantity = params.get('quantity') && !isNaN(Number(params.get('quantity'))) ? Number(params.get('quantity')) : '';
        const quantity_min = params.get('quantity_min') && !isNaN(Number(params.get('quantity_min'))) ? Number(params.get('quantity_min')) : '';
        const quantity_max = params.get('quantity_max') && !isNaN(Number(params.get('quantity_max'))) ? Number(params.get('quantity_max')) : '';
        searchOfferForm.setValue('published', published);
        searchOfferForm.setValue('name', keyword);
        searchOfferForm.setValue('condition_id', condition_id);
        searchOfferForm.setValue('category_id', category_id);
        searchOfferForm.setValue('vendorId', vendor_id);
        searchOfferForm.setValue('brand', brand);
        searchOfferForm.setValue('price_order', price_order);
        searchOfferForm.setValue('errors', errors);
        searchOfferForm.setValue('products_per_page', products_per_page);
        searchOfferForm.setValue('quantity', quantity);
        searchOfferForm.setValue('quantity_min', quantity_min);
        searchOfferForm.setValue('quantity_max', quantity_max);
    }, []);

    useEffect(() => {
        if (isEmpty) {
            toggleOfferModal.setIsToggled(true);
        }
    }, [isEmpty]);

    useEffect(() => {
        if (!filtersPanelToggler.isToggled) {
            return;
        }

        const handleClickOutside = (event: MouseEvent) => {
            if (filtersPanelRef.current && !filtersPanelRef.current.contains(event.target as Node)) {
                filtersPanelToggler.setIsToggled(false);
            }
        };

        document.addEventListener('mousedown', handleClickOutside);

        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [filtersPanelToggler.isToggled]);

    useEffect(() => {
        if (tempLoading.isToggled) {
            /* caricamento */
            logMessage.setMessageTimer(20000);
            logMessage.write('subject', 'Loading . . .');
            logMessage.write('bgColor', logMsgBgColors.loading);
        } else if (!tempLoading.isToggled) {
            logMessage.setMessageTimer(null);
        }
    }, [tempLoading.isToggled]);

    useEffect(() => {
        /* console.log(RESPONSES.createResponse, RESULTS.createResult);   */
        if (RESPONSES.createProductResponse?.ok) {
            tempLoading.setIsToggled(false);
            logMessage.write('subject', 'Offer ');
            logMessage.write('other_text', 'has been added ');
            logMessage.write('complement', 'successfully!');
            logMessage.write('bgColor', logMsgBgColors.correct);
            toggleOfferModal.setIsToggled(false);
            setRefresh((prevState) => !prevState);
            // console.log(RESULTS.createProductResult);
            window.location.href = `/offers/${RESULTS.createProductResult?.product.SKU}`;
        } else if (RESPONSES.createProductResponse?.ok === false) {
            tempLoading.setIsToggled(false);
            logMessage.write('subject', `Error ${RESPONSES.createResponse?.status}: `);
            logMessage.write('other_text', `${RESPONSES.createResponse?.statusText}`);
            logMessage.write('bgColor', logMsgBgColors.error);
        }
    }, [RESPONSES.createResponse, RESULTS.createProductResult]);

    useEffect(() => {
        if (toggleOfferModal.isToggled) {
            backToTopOfPage();
        }
    }, [toggleOfferModal]);

    const onOfferSubmit = (data: any) => {
        tempLoading.setIsToggled(true);
        if (data.long_description) {
            CTAs.createProduct(data);
        } else {
            tempLoading.setIsToggled(false);
            logMessage.write('subject', `Errore: `);
            logMessage.write('other_text', `Descrizione obbligatoria`);
            logMessage.write('bgColor', logMsgBgColors.error);
        }
        // console.log(data);
    };
    // console.log(RESULTS.createProductResult);

    useEffect(() => {
        CTAsCategory.getCategory();
        CTAsConditions.getConditions();
        CTAsVendors.getVendors();
    }, []);

    useEffect(() => {
        if (RESPONSEcatgeory.getCategoriesResponse?.ok) {
            setCategories([
                {
                    name: 'Tutti',
                    id: 'null',
                },
                ...RESULTcatgeory.getCategoriesResult.map((item: any) => ({
                    id: Number(item.id),
                    name: item.name,
                })),
            ]);
        }

        if (RESPONSEConditions.getConditionsResponse?.ok) {
            setConditions([
                {
                    name: 'Tutti',
                    id: 'null',
                },
                ...RESULTConditions.getConditionsResult.map((item: any) => ({
                    id: Number(item.id),
                    name: item.name,
                })),
            ]);
        }

        if (RESPONSEvendors.getVendorsResponse?.ok && RESULTvendors.getVendorsResult) {
            const list = Array.isArray(RESULTvendors.getVendorsResult) ? RESULTvendors.getVendorsResult : [];
            setVendors([
                { name: 'Tutti', id: 'null' },
                ...list.map((v: any) => ({ id: Number(v.id), name: v.name || v.code || `Vendor ${v.id}` })),
            ]);
        }
    }, [RESPONSEcatgeory.getCategoriesResponse, RESULTcatgeory.getCategoriesResult, RESPONSEConditions.getConditionsResponse, RESPONSEvendors.getVendorsResponse, RESULTvendors.getVendorsResult]);

    const onOfferSearch = async (obj: any) => {
        try {
            setIsLoading(true);
            setSearchObj(obj);

            const keyword = obj && obj.name && obj.name !== '' ? `keyword=${encodeURI(obj.name)}` : '';
            const published = obj && obj.published && obj.published !== 'null' && obj.published !== -1 ? `&published=${obj.published}` : '';
            const condition = obj && obj.conditionId && obj.conditionId !== 'null' && obj.conditionId !== -1 ? `&condition_id=${obj.conditionId}` : '';
            const category = obj && obj.categoryId && obj.categoryId !== 'null' && obj.categoryId !== -1 ? `&category_id=${obj.categoryId}` : '';
            const vendor = obj && obj.vendorId != null && obj.vendorId !== 'null' && obj.vendorId !== -1 ? `&vendor_id=${obj.vendorId}` : '';
            const brand = obj && obj.brand && obj.brand !== 'null' ? `&brand=${obj.brand}` : '';
            const errors = obj && obj.errors && obj.errors !== 'null' && obj.errors !== -1 ? `&errors=${obj.errors}` : '';
            const priceOrder = obj && obj.price_order && (obj.price_order === 'asc' || obj.price_order === 'desc') ? `&price_order=${obj.price_order}` : '';
            const products_per_page = obj && obj.products_per_page && obj.products_per_page !== 'null' ? `&products_per_page=${obj.products_per_page}` : '';
            const quantity = obj && obj.quantity != null && obj.quantity !== '' && !isNaN(Number(obj.quantity)) ? `&quantity=${obj.quantity}` : '';
            const quantity_min = obj && obj.quantity_min != null && obj.quantity_min !== '' && !isNaN(Number(obj.quantity_min)) ? `&quantity_min=${obj.quantity_min}` : '';
            const quantity_max = obj && obj.quantity_max != null && obj.quantity_max !== '' && !isNaN(Number(obj.quantity_max)) ? `&quantity_max=${obj.quantity_max}` : '';
            const page = obj ? '&page=1' : '';
            const url = `${apiURL}/search/${PRODUCT}?${keyword + published + condition + category + vendor + brand + errors + priceOrder + products_per_page + quantity + quantity_min + quantity_max + page}`;
            
            const header = {
                method: 'GET',
                headers: {
                    Authorization: `Bearer ${token}`,
                    'Content-type': 'application/json; charset=UTF-8',
                },
            };

            const response = await fetch(url, header);


            if (response.ok) {
                const json = await response.json();
                setSearchedProducts(json);
            }
            setIsLoading(false);

        } catch (e) {
            console.error(e);
            setIsLoading(false);
        }
    };

    const cloneProduct = useCallback(() => {
        // navigate(`/offers/${sku}`);
        setBigLoad(true);
        CTAs.cloneProduct(selectedProducts[0].SKU);
        setSelectedProducts([]);
    }, [selectedProducts]);

    const publishProducts = useCallback(() => {
        // navigate(`/offers/${sku}`);
        setBigLoad(true);
        for (const product of selectedProducts) {
            CTAs.editPublishProduct(product.SKU);
        }
        setSelectedProducts([]);
    }, [selectedProducts]);

    const deleteProducts = useCallback(() => {
        // navigate(`/offers/${sku}`);
        setBigLoad(true);
        for (const product of selectedProducts) {
            CTAs.deleteProduct(product.SKU);
        }
        setSelectedProducts([]);
    }, [selectedProducts]);

    const syncProducts = useCallback(() => {

        setBigLoad(true);
        for (const product of selectedProducts) {
            CTAs.forceSync(product.SKU);
        }
        setSelectedProducts([]);
    }, [selectedProducts]);



    /*******************************************************
     * 
     * *********************TODO****************************
     * 
     * 
     * EDIT THIS METHOD AND ADD SEARCH INPUTS IN WINDOWD.LOCALTION.HREF
     * URL AS QUERY PARAMS TO PRESERVE THE SEARCH INPUTS
     * WHEN THE USER WILL CLICK THE "GO BACK" BUTTON
     * 
     * 
     * 
     * *****************************************************
     */



    useEffect(() => {
        /* console.log(RESPONSES.createResponse, RESULTS.createResult);   */
        if (RESPONSES.cloneProductResponse?.ok) {
            var obj = searchObj;
            const keyword = obj && obj.name && obj.name !== '' ? `keyword=${encodeURI(obj.name)}` : '';
            const published = obj && obj.published && obj.published !== 'null' && obj.published !== -1 ? `&published=${obj.published}` : '';
            const condition = obj && obj.conditionId && obj.conditionId !== 'null' && obj.conditionId !== -1 ? `&condition_id=${obj.conditionId}` : '';
            const category = obj && obj.categoryId && obj.categoryId !== 'null' && obj.categoryId !== -1 ? `&category_id=${obj.categoryId}` : '';
            const vendor = obj && obj.vendorId != null && obj.vendorId !== 'null' && obj.vendorId !== -1 ? `&vendor_id=${obj.vendorId}` : '';
            const brand = obj && obj.brand && obj.brand !== 'null' ? `&brand=${obj.brand}` : '';
            const errors = obj && obj.errors && obj.errors !== 'null' && obj.errors !== -1 ? `&errors=${obj.errors}` : '';
            const priceOrder = obj && obj.price_order && (obj.price_order === 'asc' || obj.price_order === 'desc') ? `&price_order=${obj.price_order}` : '';
            const products_per_page = obj && obj.products_per_page && obj.products_per_page !== 'null' ? `&products_per_page=${obj.products_per_page}` : '';
            const quantity = obj && obj.quantity != null && obj.quantity !== '' && !isNaN(Number(obj.quantity)) ? `&quantity=${obj.quantity}` : '';
            const quantity_min = obj && obj.quantity_min != null && obj.quantity_min !== '' && !isNaN(Number(obj.quantity_min)) ? `&quantity_min=${obj.quantity_min}` : '';
            const quantity_max = obj && obj.quantity_max != null && obj.quantity_max !== '' && !isNaN(Number(obj.quantity_max)) ? `&quantity_max=${obj.quantity_max}` : '';
            window.location.href = `/offers/${RESULTS.cloneProductResult.product.SKU}?${keyword + published + condition + category + vendor + brand + errors + priceOrder + products_per_page + quantity + quantity_min + quantity_max}`;
        } else if (RESPONSES.cloneProductResponse?.ok === false) {
            tempLoading.setIsToggled(false);
            logMessage.write('subject', `Error ${RESPONSES.cloneProductResponse?.status}: `);
            logMessage.write('other_text', `${RESPONSES.cloneProductResponse?.statusText}`);
            logMessage.write('bgColor', logMsgBgColors.error);
            setPopupPublish(false);
            setBigLoad(false);
        }
    }, [RESPONSES.cloneProductResponse, RESULTS.cloneProductResult]);

    useEffect(() => {
        /* console.log(RESPONSES.createResponse, RESULTS.createResult);   */
        if (RESPONSES.editPublishProductResponse?.ok) {
            setPopupPublish(false);
            setBigLoad(false);
            tempLoading.setIsToggled(false);
            logMessage.write('subject', 'Products ');
            logMessage.write('other_text', 'has been published ');
            logMessage.write('complement', 'successfully!');
            logMessage.write('bgColor', logMsgBgColors.correct);
            toggleOfferModal.setIsToggled(false);
            setUpdateTable(true);
            // console.log(RESULTS.createProductResult);
        } else if (RESPONSES.cloneProductResponse?.ok === false) {
            tempLoading.setIsToggled(false);
            logMessage.write('subject', `Error ${RESPONSES.editPublishProductResponse?.status}: `);
            logMessage.write('other_text', `${RESPONSES.editPublishProductResponse?.statusText}`);
            logMessage.write('bgColor', logMsgBgColors.error);
            setPopupPublish(false);
            setBigLoad(false);
        }
    }, [RESPONSES.editPublishProductResponse, RESULTS.editPublishProductResult]);

    useEffect(() => {
        /* console.log(RESPONSES.createResponse, RESULTS.createResult);   */
        if (RESPONSES.deleteProductResponse?.ok) {
            setPopupDelete(false);
            setBigLoad(false);
            tempLoading.setIsToggled(false);
            logMessage.write('subject', 'Products ');
            logMessage.write('other_text', 'has been deleted ');
            logMessage.write('complement', 'successfully!');
            logMessage.write('bgColor', logMsgBgColors.correct);
            toggleOfferModal.setIsToggled(false);
            setUpdateTable(true);
            // console.log(RESULTS.createProductResult);
        } else if (RESPONSES.deleteProductResponse?.ok === false) {
            tempLoading.setIsToggled(false);
            logMessage.write('subject', `Error ${RESPONSES.deleteProductResponse?.status}: `);
            logMessage.write('other_text', `${RESPONSES.deleteProductResponse?.statusText}`);
            logMessage.write('bgColor', logMsgBgColors.error);
            setPopupDelete(false);
            setBigLoad(false);
        }
    }, [RESPONSES.deleteProductResponse, RESULTS.deleteProductResult]);

    useEffect(() => {
        if (RESPONSES.forceProductSyncResponse?.ok) {
            setPopupForceSync(false);
            setBigLoad(false);
            tempLoading.setIsToggled(false);
            logMessage.write('subject', 'Products ');
            logMessage.write('other_text', 'has been deleted ');
            logMessage.write('complement', 'successfully!');
            logMessage.write('bgColor', logMsgBgColors.correct);
            toggleOfferModal.setIsToggled(false);
            setUpdateTable(true);
            // console.log(RESULTS.createProductResult);
        } else if (RESPONSES.forceProductSyncResponse?.ok === false) {
            tempLoading.setIsToggled(false);
            logMessage.write('subject', `Error ${RESPONSES.forceProductSyncResponse?.status}: `);
            logMessage.write('other_text', `${RESPONSES.forceProductSyncResponse?.statusText}`);
            logMessage.write('bgColor', logMsgBgColors.error);
            setPopupForceSync(false);
            setBigLoad(false);
        }
    }, [RESPONSES.forceProductSyncResponse, RESULTS.forceProductSyncResult]);


    // useEffect(() => {
    //     if (RESPONSES.filterProductsResponse?.ok) {
    //         console.log(RESULTS.filterProductsResult);
    //     }
    // }, [RESPONSES.filterProductsResponse, RESULTS.filterProductsResult, setOfferOnSearchName, isLoading]);

    return (
        <div
            className='page-wrapper'
            style={
                {
                    /* overflowY: isMobile && menuToggler.isToggled ? "hidden" : "scroll",   */
                }
            }
        >
            {bigLoad && (
                <div className='bigLoader'>
                    <Loader />
                </div>
            )}
            {popupPublish && (
                <CustomModal setShow={setPopupPublish} title='Pubblica' description='Sei sicuro di volere pubblicare questi prodotti?' ctaTtitle='Pubblica' ctaFunction={publishProducts}>
                    <div>
                        <p style={{ width: 'fit-content' }} className='sidebar-user-info-name'>
                            I seguenti prodotti verranno pubblicati:
                        </p>
                        {selectedProducts.map((item, i) => {
                            return (
                                <>
                                    {item.quantity > 0 && (
                                        <div key={i}>
                                            <p style={{ width: 'fit-content' }} className='sidebar-user-info-name'>
                                                - {item.title}
                                            </p>
                                        </div>
                                    )}
                                </>
                            );
                        })}
                        <p style={{ width: 'fit-content', marginTop: 30 }} className='sidebar-user-info-name'>
                            I seguenti prodotti non verranno pubblicati perchè hanno qta. 0:
                        </p>
                        {selectedProducts.map((item, i) => {
                            return (
                                <>
                                    {item.quantity <= 0 && (
                                        <div key={i}>
                                            <p style={{ width: 'fit-content' }} className='sidebar-user-info-name'>
                                                - {item.title}
                                            </p>
                                        </div>
                                    )}
                                </>
                            );
                        })}
                    </div>
                </CustomModal>
            )}




            {popupForceSync && (
                <CustomModal setShow={setPopupForceSync} title='Sincronizza' description='Sei sicuro di voler sincronizzare questi prodotti?' ctaTtitle='Sincronizza' ctaFunction={syncProducts}>
                    <div>
                        <p style={{ width: 'fit-content' }} className='sidebar-user-info-name'>
                            I seguenti prodotti verrnno forzatamente sincornizzati allo stato attuale, indipendentemente dal loro stato di pubblicazione:
                        </p>
                        {selectedProducts.map((item, i) => {
                            return (
                                <>
                                    {item.quantity > 0 && (
                                        <div key={i}>
                                            <p style={{ width: 'fit-content' }} className='sidebar-user-info-name'>
                                                - {item.title}
                                            </p>
                                        </div>
                                    )}
                                </>
                            );
                        })}
                    </div>
                </CustomModal>
            )}

            {popupDelete && (
                <CustomModal setShow={setPopupDelete} title='Elmina' description='Sei sicuro di volere eliminare questi prodotti?' ctaTtitle='Elimina' ctaFunction={deleteProducts}>
                    <div>
                        <p style={{ width: 'fit-content' }} className='sidebar-user-info-name'>
                            I seguenti prodotti non saranno eliminiti perché la quantità è maggiore di 0:
                        </p>
                        {selectedProducts.map((item, i) => {
                            return (
                                <>
                                    {item.quantity > 0 && (
                                        <div key={i}>
                                            <p style={{ width: 'fit-content' }} className='sidebar-user-info-name'>
                                                - {item.title}
                                            </p>
                                        </div>
                                    )}
                                </>
                            );
                        })}
                        <p style={{ width: 'fit-content', marginTop: 30 }} className='sidebar-user-info-name'>
                            I seguenti prodotti verranno eliminati:
                        </p>
                        {selectedProducts.map((item, i) => {
                            return (
                                <>
                                    {item.quantity === 0 && (
                                        <div key={i}>
                                            <p style={{ width: 'fit-content' }} className='sidebar-user-info-name'>
                                                - {item.title}
                                            </p>
                                        </div>
                                    )}
                                </>
                            );
                        })}
                    </div>
                </CustomModal>
            )}
            <form onSubmit={createOfferForm.handleSubmit(onOfferSubmit)}>
                {toggleOfferModal.isToggled && (
                    <OfferCreateModal toggler={toggleOfferModal} setValue={createOfferForm.setValue} register={createOfferForm.register} errors={createOfferForm.formState.errors} onEdit={false} />
                )}
            </form>
            {(!isMobile || menuToggler.isToggled) && <SideBar toggler={menuToggler} />}
            <div>
                {isMobile && <NavBar toggler={menuToggler} />}
                <div
                    className={`page-content ${isMobile && menuToggler.isToggled ? (menuToggler.isToggledSecondary ? 'slide-right' : 'slide-left') : ''}`}
                    style={{
                        maxWidth: isMobile ? '' : 'calc(100vw - 256px)',
                        minWidth: isMobile ? '' : '1105px',
                        marginLeft: isMobile ? (menuToggler.isToggled ? '256px' : '') : '256px',
                        display: toggleOfferModal.isToggled && isMobile ? 'none' : '',
                    }}
                >
                    {logMessage.isToggled && (
                        <LogMessage
                            text={{
                                subject: logMessage.message.subject,
                                other_text: logMessage.message.other_text,
                                complement: logMessage.message.complement,
                            }}
                            bgColor={logMessage.message.bgColor}
                        />
                    )}

                    <div
                        className='offers-content shadow'
                        style={{
                            width: isMobile ? '354px' : '',
                            margin: isMobile ? '0 16px 0' : '',
                        }}
                    >
                        <div
                            className='search-box-content'
                            style={{
                                width: isMobile ? '305px' : '',
                                margin: isMobile ? ' 32px auto 0 ' : '',
                            }}
                        >
                            <div >
                                <form onSubmit={searchOfferForm.handleSubmit(onOfferSearch)}>
                                    <SearchBar
                                        notify={false}
                                        width={isMobile ? 170 : 332}
                                        defaultValue={queryParam.name ? queryParam.name : ''}
                                        iconShift={isMobile ? 20 : 11}
                                        register={searchOfferForm.register}
                                    />
                                    <div className='offers-search-actions'>
                                        <div className='offers-filters-dropdown-wrap' ref={filtersPanelRef}>
                                            <button
                                                type='button'
                                                className='modal-button offers-filters-trigger'
                                                onClick={filtersPanelToggler.toggle}
                                            >
                                                <p className='add-buttonText'>Filtri</p>
                                                <span style={{ marginLeft: 4, display: 'inline-block', transform: filtersPanelToggler.isToggled ? 'rotate(180deg)' : 'none', fontSize: 10 }}>▼</span>
                                            </button>
                                            {filtersPanelToggler.isToggled && (
                                                <div className='offers-filters-dropdown'>
                                                    <div className='offers-search-filters'>
                                                        <CustomInput
                                                            title={'Condizione'}
                                                            name='conditionId'
                                                            width={isMobile ? '100%' : 160}
                                                            type='select'
                                                            options={conditions}
                                                            register={searchOfferForm.register}
                                                            errors={searchOfferForm.formState.errors}
                                                            defaultValue={queryParam.conditionId >= 0 ? queryParam.conditionId : undefined}
                                                            idValue={true}
                                                        />
                                                        <CustomInput
                                                            title={'Stato'}
                                                            name='published'
                                                            width={isMobile ? '100%' : 140}
                                                            type='select'
                                                            options={publishedOptions}
                                                            register={searchOfferForm.register}
                                                            errors={searchOfferForm.formState.errors}
                                                            defaultValue={queryParam.published}
                                                            idValue={true}
                                                        />
                                                        <CustomInput
                                                            title={'Categoria'}
                                                            name='categoryId'
                                                            width={isMobile ? '100%' : 160}
                                                            type='select'
                                                            options={categories}
                                                            register={searchOfferForm.register}
                                                            errors={searchOfferForm.formState.errors}
                                                            defaultValue={queryParam.categoryId >= 0 ? queryParam.categoryId : undefined}
                                                            idValue={true}
                                                        />
                                                        <CustomInput
                                                            title={'Vendor'}
                                                            name='vendorId'
                                                            width={isMobile ? '100%' : 160}
                                                            type='select'
                                                            options={vendors}
                                                            register={searchOfferForm.register}
                                                            errors={searchOfferForm.formState.errors}
                                                            defaultValue={queryParam.vendorId != null && queryParam.vendorId !== -1 ? queryParam.vendorId : 'null'}
                                                            idValue={true}
                                                        />
                                                        <CustomInput
                                                            title={'Brand'}
                                                            name='brand'
                                                            width={isMobile ? '100%' : 140}
                                                            type='text'
                                                            register={searchOfferForm.register}
                                                            errors={searchOfferForm.formState.errors}
                                                            defaultValue={queryParam.brand ?? ''}
                                                        />
                                                        <CustomInput
                                                            title={'Errori'}
                                                            name='errors'
                                                            width={isMobile ? '100%' : 130}
                                                            type='select'
                                                            options={[
                                                                { name: 'Seleziona', id: 'null' }, { name: 'ERROR', id: 'ERROR' }, { name: 'SENT', id: 'SENT' }, { name: 'WARNING', id: 'WARNING' }
                                                            ]}
                                                            register={searchOfferForm.register}
                                                            errors={searchOfferForm.formState.errors}
                                                            defaultValue={queryParam.errors}
                                                            idValue={true}
                                                        />
                                                        <CustomInput
                                                            title={'Ordinamento Prezzo'}
                                                            name='price_order'
                                                            width={isMobile ? '100%' : 150}
                                                            type='select'
                                                            options={[{ name: 'Seleziona', id: 'null' }, { name: 'Crescente', id: 'asc' }, { name: 'Decrescente', id: 'desc' }]}
                                                            register={searchOfferForm.register}
                                                            errors={searchOfferForm.formState.errors}
                                                            defaultValue={queryParam.price_order}
                                                            idValue={true}
                                                        />
                                                        <CustomInput
                                                            title={'Quantità (esatta)'}
                                                            name='quantity'
                                                            width={isMobile ? '100%' : 100}
                                                            type='number'
                                                            register={searchOfferForm.register}
                                                            errors={searchOfferForm.formState.errors}
                                                            defaultValue={queryParam.quantity ?? ''}
                                                            placeholder='Es. 5'
                                                        />
                                                        <CustomInput
                                                            title={'Quantità min'}
                                                            name='quantity_min'
                                                            width={isMobile ? '100%' : 100}
                                                            type='number'
                                                            register={searchOfferForm.register}
                                                            errors={searchOfferForm.formState.errors}
                                                            defaultValue={queryParam.quantity_min ?? ''}
                                                            placeholder='Min'
                                                        />
                                                        <CustomInput
                                                            title={'Quantità max'}
                                                            name='quantity_max'
                                                            width={isMobile ? '100%' : 100}
                                                            type='number'
                                                            register={searchOfferForm.register}
                                                            errors={searchOfferForm.formState.errors}
                                                            defaultValue={queryParam.quantity_max ?? ''}
                                                            placeholder='Max'
                                                        />
                                                        <CustomInput
                                                            title={'Paginazione'}
                                                            name='products_per_page'
                                                            width={isMobile ? '100%' : 120}
                                                            type='select'
                                                            options={[
                                                                { name: 100, id: 100 }, { name: 50, id: 50 }, { name: 20, id: 20 }, { name: 10, id: 10 }, { name: 5, id: 5 }
                                                            ]}
                                                            register={searchOfferForm.register}
                                                            errors={searchOfferForm.formState.errors}
                                                            defaultValue={queryParam.products_per_page}
                                                            idValue={true}
                                                        />
                                                    </div>
                                                    <button type='submit' className='modal-button' style={{ marginTop: 12 }}>
                                                        <p className='add-buttonText'>Applica filtri</p>
                                                    </button>
                                                </div>
                                            )}
                                        </div>
                                        <div className='quickActions'>
                                        <button className='modal-button' style={{ visibility: isFastEdit ? 'hidden' : 'visible', margin: 0 }} type='submit'>
                                            <p className='add-buttonText'>Cerca</p>
                                        </button>
                                        <button className='modal-button' style={{ margin: 2, background: "green" }} type='button' onClick={() => {searchOfferForm.reset(); queryParam.name=''; searchOfferForm.setValue('keyword','')}}>
                                            <p className='add-buttonText'>Pulisci</p>
                                        </button>
                                    </div>
                                    </div>

                                </form>
                                <div className='quickActions'>
                                    <p className='sidebar-user-info-name' style={{ margin: 0 }}>
                                        Azioni rapide:
                                    </p>
                                    <button
                                        className='modal-button'
                                        style={{
                                            margin: 0,
                                            opacity: selectedProducts.length > 0 && selectedProducts.length < 2 ? 1 : 0.3,
                                            pointerEvents: selectedProducts.length > 0 && selectedProducts.length < 2 ? 'auto' : 'none',
                                        }}
                                        onClick={cloneProduct}
                                    >
                                        <p className='add-buttonText'>Clona</p>
                                    </button>
                                    <button
                                        className='modal-button'
                                        style={{ margin: 0, opacity: selectedProducts.length > 0 ? 1 : 0.3, pointerEvents: selectedProducts.length > 0 ? 'auto' : 'none' }}
                                        onClick={() => setPopupPublish(true)}
                                    >
                                        <p className='add-buttonText'>Pubblica</p>
                                    </button>
                                    <button
                                        className='modal-button'
                                        style={{
                                            background: 'red',
                                            color: 'white',
                                            margin: 0,
                                            opacity: selectedProducts.length > 0 ? 1 : 0.3,
                                            pointerEvents: selectedProducts.length > 0 ? 'auto' : 'none',
                                        }}
                                        onClick={() => setPopupDelete(true)}
                                    >
                                        <p className='add-buttonText'>Elimina</p>
                                    </button>
                                    <button
                                        className='modal-button'
                                        style={{
                                            background: 'black',
                                            color: 'white',
                                            margin: 0,
                                            opacity: selectedProducts.length > 0 ? 1 : 0.3,
                                            pointerEvents: selectedProducts.length > 0 ? 'auto' : 'none',
                                        }}
                                        onClick={() => setPopupForceSync(true)}
                                    >
                                        <p className='add-buttonText'>Forza Sync</p>
                                    </button>
                                </div>
                            </div>
                            <button className='add-button' type='button' onClick={toggleOfferModal.toggle} style={{ width: isMobile ? '56px' : '' }}>
                                <img className='white' src={`${toIcons}/plus.svg`} />
                                {!isMobile && <p className='add-buttonText'>New Offer</p>}
                            </button>
                        </div>
                        <div
                            style={{
                                display: 'flex',
                                flexDirection: 'column',
                                alignItems: 'center',
                            }}
                        >
                            <OffersTable
                                isLoading={isLoading}
                                obj={searchObj}
                                searchedProducts={searchedProducts}
                                selectedProducts={selectedProducts}
                                setSelectedProducts={setSelectedProducts}
                                loadMoreToggler={loadMoreToggler}
                                loadMoreCounter={loadMoreCounter}
                                conditions={conditions}
                                categories={categories}
                                updateTable={updateTable}
                                setUpdateTable={setUpdateTable}
                                setFastEdit={setFastEdit}
                            />
                            {/*  <div
                style={{
                  marginTop: "20px",
                  marginBottom: "40px",
                }}
              >
                {!loadMoreToggler.isToggled && (
                  <button
                    className="button2"
                    type="button"
                    onClick={() => {
                      setLoadMoreCounter((prevCounter) => prevCounter + 1);
                    }}
                  >
                    <p className="button2-text">Load More</p>
                  </button>
                )}
              </div> */}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};
export default OffersPage;
